import angular from 'angular';
import $ from 'jquery';
import logger from '../../../../../shared/logger';

export const ActiveJobsService = (StatsService, $q, $filter) => {
    const getActiveJobsData = function (callback) {
        StatsService.getActiveClaimedJobs()
            .then((response) => {
                const dataSource = [];
                let activeJobsCount = 0;
                for (let i = 0; i < response.result.length; i++) {
                    if (response.result[i].isPositionClaimed) {
                        dataSource.push({
                            jobType: $filter('translate')('CLAIMED'),
                            jobsCount: response.result[i].count,
                        });
                    } else {
                        dataSource.push({
                            jobType: $filter('translate')('AVAILABLE'),
                            jobsCount: response.result[i].count,
                        });
                    }
                    activeJobsCount += response.result[i].count;
                }

                const options = {
                    type: 'doughnut',
                    dataSource,
                    size: {
                        height: 186,
                        width: 140,
                    },
                    innerRadius: 0.75,
                    palette: ['#F8C052', '#CE5C32'],
                    legend: {
                        customizeText() {
                            const name = this.pointName;
                            let value;
                            $.each(dataSource, (_, item) => {
                                if (item.jobType === name) {
                                    value = item.jobsCount;
                                    return false;
                                }
                            });
                            return `${this.pointName} (${value})`;
                        },
                        font: {
                            color: '#000000',
                            family: 'Source Sans Pro',
                            weight: 400,
                            size: 15,
                        },
                        orientation: 'vertical',
                        verticalAlignment: 'bottom',
                        horizontalAlignment: 'center',
                        itemsAlignment: 'left',
                        itemTextPosition: 'right',
                        markerSize: 10,
                        paddingTopBottom: 22,
                    },

                    onPointClick(arg) {
                        arg.target.select();
                    },
                    export: {
                        enabled: false,
                    },
                    series: [{
                        argumentField: 'jobType',
                        valueField: 'jobsCount',
                        hoverStyle: {
                            color: '#ffd700',
                        },
                    }],
                };
                callback({
                    options,
                    activeJobsCount,
                });
            })
            .catch(err => logger.error(err));
    };

    return {
        getActiveJobsData,
    };
};

angular
    .module('TALENYA-FE')
    .factory('ActiveJobsService', ActiveJobsService);
